export const mediaQueryServiceConfig = {
  "viewports": [
    {
      "id": "xs",
      "description": "xsmall",
      "query": "screen and (max-width: 767px)",
      "photoWidth": 640,
      "photoGalleryWidth": 767
    },
    {
      "id": "sm",
      "description": "small",
      "query": "screen and (min-width: 768px) and (max-width: 991px)",
      "photoWidth": 640,
      "photoGalleryWidth": 991
    },
    {
      "id": "md",
      "description": "medium",
      "query": "screen and (min-width: 992px) and (max-width: 1199px)",
      "photoWidth": 640,
      "photoGalleryWidth": 1199
    },
    {
      "id": "lg",
      "description": "large",
      "query": "screen and (min-width: 1200px)",
      "photoWidth": 640,
      "photoGalleryWidth": 1200
    }
  ],
  "orientations": [
    {
      "id": "portrait",
      "query": "screen and (orientation: portrait)"
    },
    {
      "id": "landscape",
      "query": "screen and (orientation: landscape)"
    }
  ]
};






// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/media-query/media-query.config.ts